import { render, staticRenderFns } from "./LoginPage.vue?vue&type=template&id=5ac1e4a4"
import script from "../controllers/login-page.js?vue&type=script&lang=js&external"
export * from "../controllers/login-page.js?vue&type=script&lang=js&external"
import style0 from "./LoginPage.vue?vue&type=style&index=0&id=5ac1e4a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports